import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FloatingMenu from '../../../components/floatingMenu/floatingMenu';
import {
  faUserGear,
  faChalkboardUser,
  faFileExport,
  faTrashCan
} from '@fortawesome/free-solid-svg-icons';
import { faTrashCanUndo } from '@fortawesome/pro-solid-svg-icons';

const FloatingBar = ({
  selectedItems,
  onAction,
  activeTab,
  showRestore
}) => {
  const hasDeletedSelection = selectedItems.some((set) => set.isDeleted);
  const hasSelection = selectedItems.length > 0;

  const getActionDisabled = (item) => {
    if (item.disabled) {
      return true;
    }
    if (!hasSelection) {
      return true;
    }
    if (selectedItems.length > 1 && !item.isMultiSelectEnabled) {
      return true;
    }
    return false;
  };

  const floatingMenu = [
    {
      id: 1,
      action: 'transfer_to_administrator',
      name: 'Transfer to Administrator',
      tooltip: 'Transfer to Administrator',
      icon: <FontAwesomeIcon icon={faUserGear} />,
      isMultiSelectEnabled: true,
      disabled: hasDeletedSelection,
      setType: ['questionsets', 'resourcesets']
    },
    {
      id: 2,
      action: 'transfer_to_teacher',
      name: 'Transfer to Teacher',
      tooltip: 'Transfer to Teacher',
      icon: <FontAwesomeIcon icon={faChalkboardUser} />,
      isMultiSelectEnabled: true,
      disabled: hasDeletedSelection,
      setType: ['questionsets', 'resourcesets', 'flashcardsets']
    },
    {
      id: 3,
      action: 'export_to_xml_file',
      name: 'Export to XML file',
      tooltip: 'Export to XML file',
      icon: <FontAwesomeIcon icon={faFileExport} />,
      isMultiSelectEnabled: true,
      disabled: hasDeletedSelection,
      setType: ['questionsets']
    },
    {
      id: 4,
      action: 'delete',
      name: showRestore && hasDeletedSelection ? 'Restore Deleted' : 'Delete',
      tooltip: showRestore && hasDeletedSelection ? 'Restore Deleted' : 'Delete',
      icon: showRestore && hasDeletedSelection ? (
        <FontAwesomeIcon icon={faTrashCanUndo} />
      ) : (
        <FontAwesomeIcon icon={faTrashCan} />
      ),
      isMultiSelectEnabled: true,
      disabled: false,
      setType: ['questionsets', 'resourcesets', 'flashcardsets']
    },
  ];

  const filteredMenu = floatingMenu
    .filter((x) => x.setType.includes(activeTab))
    .map((item) => ({
      id: item.id,
      name: item.name,
      tooltip: item.tooltip,
      icon: item.icon,
      disabled: getActionDisabled(item),
      action: item.action
    }));

  const handleFloatingClick = (buttonId) => {
    const selectedAction = filteredMenu.find((item) => item.id === buttonId);
    if (!selectedAction || selectedAction.disabled) {
      return;
    }
    onAction(selectedAction.action);
  };

  return (
    <div className='d-flex my-content-floating-menu-container justify-content-center'>
      <FloatingMenu floatingButtons={filteredMenu} onClick={handleFloatingClick} />
    </div>
  );
};

FloatingBar.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  onAction: PropTypes.func.isRequired,
  activeTab: PropTypes.string,
  showRestore: PropTypes.bool
};

export default FloatingBar;